<script lang="ts">
	import { format } from 'svelte-i18n';
	import { createEventDispatcher } from 'svelte';

	import SingleRowView from '../../components/GenericView/SingleRowView.svelte';
	import { actionInterpretator } from '../../helpers/scene_actions_to_ui';
	import type { DeviceActionUI } from '../../../../types/DeviceActionUI';
	import type { NotificationActionUI } from '../../../../types/NotificationActionUI';
	import type { SceneActionUI } from '../../../../types/SceneActionUI';
	import type { RunScriptActionUI } from '../../../../types/RunScriptActionUI';
	import { extract_actions_variables } from './extract_actions_variables';
	import type { GroupActionUI } from '../../../../types/GroupActionUI';
	import {
		getDelayedSceneAction,
		getSceneActionPurpose,
	} from '../../helpers/get_delayed_scene_action';

	import { Label, Stack, Text } from '@Shelly/shelly-design-system';

	export let element; //only action types will be here, but its possible to be do or [do, delay], [delay, do]

	const dispatch = createEventDispatcher();

	const isNestedBlock = element && typeof element === 'object' && 'if' in element && 'do' in element;
	const delayedAction = getDelayedSceneAction(element);
	const msgType = element.msg_type;
	const purpose = getSceneActionPurpose(element, delayedAction);
	let previewElement = element;
	let display_modal = false;
	let translated:
		| NotificationActionUI
		| DeviceActionUI
		| SceneActionUI
		| GroupActionUI
		| RunScriptActionUI
		| undefined;
	let title: any = '';
	let subtitle: any = '';
	let labelList: any[] = [];
	let withLabelList = false;
	let avatar: any;
	let description: any = '';
	let actionList: any[] = [];

	if (delayedAction !== undefined && element.wait !== undefined) {
		previewElement = { ...delayedAction, delay: element.wait, units: element.units };
	}

	if (isNestedBlock) {
		title = $format('title_nested_condition', { default: 'Nested condition' });
		subtitle = {
			value: $format('description_nested_condition', { default: 'Contains conditional logic' }),
			bold: false,
		};
	} else {
		translated = actionInterpretator(purpose, previewElement, msgType);

		({ title, subtitle, labelList, withLabelList, avatar, description, actionList } =
			extract_actions_variables(translated));
	}

	const handle_click = () => {
		display_modal = true;
	};
</script>

{#if isNestedBlock}
	<div class="nested-block-preview">
		<div class="nested-icon"><i class="fa fa-code-branch"></i></div>
		<div class="nested-info">
			<Text variant="body" size="m">{title}</Text>
			<span class="nested-subtitle"><Text variant="body" size="s">{subtitle.value}</Text></span>
		</div>
	</div>
{:else}
	<SingleRowView
		element={previewElement}
		{withLabelList}
		{labelList}
		{avatar}
		{title}
		{subtitle}
		{description}
		on:click={() => {
			dispatch('edit-do');
		}}
		on:open_detailed={() => handle_click()}
	/>

	{#if actionList && actionList.length > 0}
		<Stack gap="s" class="mt-s">
			{#each actionList as { icon, name }}
				<Label class="width-full justify-content-start" {icon} value={name} size="s" />
			{/each}
		</Stack>
	{/if}
{/if}

<style>
	.nested-block-preview {
		display: flex;
		align-items: center;
		gap: 0.75rem;
		padding: 0.75rem;
	}

	.nested-icon {
		color: var(--color-text-secondary, #9ca3af);
		font-size: 1.25rem;
	}

	.nested-info {
		display: flex;
		flex-direction: column;
		gap: 0.125rem;
	}

	.nested-subtitle {
		color: var(--color-text-secondary, #9ca3af);
	}
</style>
